import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => {
  const { secondary, warning } = theme.palette;

  return {
    lastExamCell: {
      display: "flex",
      alignItems: "center"
    },
    icon: {
      fontWeight: "bold",
      fontSize: 18
    },
    success: {
      color: secondary.dark
    },
    fail: {
      color: warning.dark
    }
  };
});
